// Fotos de la Galería. category = posición en translations.gallery.categories (0 = "Todos").
// 1 Asesorías · 2 Procesos comunitarios · 3 Actividades de campo · 4 Metodologías y materiales
// 5 Ciencia ciudadana · 6 Interpretación ambiental
// alt: descripción de la foto para lectores de pantalla (es/en).
// credit: nombre del autor; null -> sin crédito (no se muestra). w/h: medidas reales del archivo.

const OET = { es: 'Organización para Estudios Tropicales', en: 'Organization for Tropical Studies' };

export const galleryItems = [
  {
    src: '/images/galeria/asesoria-presentacion-mapa.jpg', category: 1, credit: null, w: 575, h: 761,
    alt: { es: 'Dos facilitadoras presentan un mapa del cantón en una charla', en: 'Two facilitators present a map of the canton during a talk' },
  },
  {
    src: '/images/galeria/actividad-campo-mesas.jpg', category: 3, credit: null, w: 1280, h: 960,
    alt: { es: 'Grupo reunido en mesas de madera bajo un rancho', en: 'Group gathered at wooden tables under an open-air shelter' },
  },
  {
    src: '/images/galeria/ninos.jpg', category: 5, credit: null, w: 1600, h: 1067,
    alt: { es: 'Niñas y niños observan con atención junto a una facilitadora', en: 'Children look closely alongside a facilitator' },
  },
  {
    src: '/images/proyectos/sensibilizacion-comunidades.jpg', category: 1, credit: 'A. Sánchez', w: 1050, h: 497,
    alt: { es: 'Vecinas participan en una actividad de sensibilización', en: 'Neighbors take part in an awareness activity' },
  },
  {
    src: '/images/galeria/procesos-charla-salon.jpg', category: 2, credit: null, w: 1152, h: 864,
    alt: { es: 'Charla comunitaria en un salón con proyección', en: 'Community talk in a hall with a projected presentation' },
  },
  {
    src: '/images/galeria/ecomaletas.jpg', category: 4, credit: 'Y. Blanco', w: 1600, h: 900,
    alt: { es: 'Facilitadoras con máscaras de aves en una actividad lúdica', en: 'Facilitators wearing bird masks during a playful activity' },
  },
  {
    src: '/images/galeria/mascaras-animales.jpg', category: 4, credit: 'A. Sánchez', w: 1020, h: 767,
    alt: { es: 'Niños con máscaras de mono y de felino hechas a mano', en: 'Children wearing handmade monkey and wild cat masks' },
  },
  {
    src: '/images/galeria/procesos-comunidad-agua.jpg', category: 2, credit: null, w: 1020, h: 766,
    alt: { es: 'Comunidad reunida junto a un sistema de captación de agua', en: 'Community gathered by a water collection system' },
  },
  {
    src: '/images/galeria/ciencia-ciudadana-rio.jpg', category: 5, credit: 'C. Nourissat', w: 507, h: 767,
    alt: { es: 'Niño levanta la mano durante una actividad a la orilla del río', en: 'A boy raises his hand during an activity on the riverbank' },
  },
  {
    src: '/images/galeria/actividad-campo-reforestacion.jpg', category: 3, credit: null, w: 585, h: 710,
    alt: { es: 'Grupo de mujeres con palas en una jornada de reforestación', en: 'Group of women with shovels during a reforestation day' },
  },
  {
    src: '/images/galeria/rutas-migracion.jpg', category: 4, credit: null, w: 572, h: 765,
    alt: { es: 'Niños señalan un mural de rutas de migración de aves', en: 'Children point at a mural of bird migration routes' },
  },
  {
    src: '/images/proyectos/eco-maletas-lanzamiento.jpg', category: 4, credit: OET, w: 1121, h: 841,
    alt: { es: 'Lanzamiento de las Eco-Maletas con estudiantes', en: 'Launch of the Eco-Maletas with students' },
  },
  {
    src: '/images/galeria/interpretacion-palma.jpg', category: 6, credit: null, w: 810, h: 493,
    alt: { es: 'Guía señala las hojas de una cícada durante un recorrido', en: 'A guide points to the leaves of a cycad during a walk' },
  },
  {
    src: '/images/galeria/interpretacion-semillas.jpg', category: 6, credit: 'C. Nourissat', w: 1150, h: 767,
    alt: { es: 'Niña sostiene un fruto abierto con semillas', en: 'A girl holds an open seed pod' },
  },
  {
    src: '/images/galeria/interpretacion-flor.jpg', category: 6, credit: null, w: 513, h: 697,
    alt: { es: 'Guía observa de cerca una inflorescencia en el bosque', en: 'A guide closely observes an inflorescence in the forest' },
  },
  {
    src: '/images/galeria/interpretacion-mochila-mariposas.jpg', category: 6, credit: null, w: 567, h: 768,
    alt: { es: 'Grupo en un sendero; una mochila lleva una guía de mariposas', en: 'Group on a trail; a backpack carries a butterfly guide' },
  },
];
